import { loadApplications, loadMcpServers } from '../api/applications';
import { ResourceType as AiAppsResourceType } from '../types/ai-apps';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import type { ResourceItem } from 'vince-core/types/common';
import { ResourceType } from 'vince-core/types/common';
import { getActions } from 'vince-core/constants/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource(AiAppsResourceType.MCP_SERVER.toString(), 'ai-apps.mcpServersMenu', [Action.WRITE, Action.READ], async () => {
        return await loadMcpServers().then((servers) => {
            return servers.map((it) => {
                return {
                    id: it.id,
                    key: it.id,
                    label: it.name,
                    description: it.systemPrompt,
                    resourceType: AiAppsResourceType.MCP_SERVER.toString(),
                    usable: true,
                    labels: []
                } as ResourceItem;
            });
        });
    }, 'pi pi-server');

    store.registerResource(ResourceType.MCP_SERVER, 'ai-apps.resource.mcpServer', getActions(ResourceType.MCP_SERVER), async () => {
        const servers = await loadMcpServers();
        return servers.map(it => ({ id: it.id, key: it.id, label: it.name, resourceType: ResourceType.MCP_SERVER } as ResourceItem));
    }, undefined, [ResourceType.MCP_SERVER]);

    store.registerResource(ResourceType.TENANT_PROMPT, 'ai-apps.resource.tenantPrompt', getActions(ResourceType.TENANT_PROMPT), () => Promise.resolve([]), undefined, [ResourceType.TENANT_PROMPT]);

    store.registerResource('AI_APP', 'addon.app.aiApps', [Action.WRITE, Action.READ], async () => {
        const applications = await loadApplications({ sort: 'name' });
        return applications.map(it => ({
            id: it.id,
            key: it.id,
            label: it.name,
            resourceType: 'AI_APP',
            usable: true
        }));
    }, undefined, [ResourceType.APP]);
});
